import { LeadFilterConditionOperatorEnums } from "@grudder/types/lead-filter-types"

export const FILTER_FIELD_TYPES = {
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    BOOLEAN: 'BOOLEAN',
    ARRAY: 'ARRAY',
    EMAIL: 'EMAIL',
    PHONE: 'PHONE',
}

export const FILTER_CONDITION_OPERATORS = {
    NOT: {
        key: LeadFilterConditionOperatorEnums.NOT,
        name: 'Not'
    },
    OR: {
        key: LeadFilterConditionOperatorEnums.OR,
        name: 'Or'
    },
    AND: {
        key: LeadFilterConditionOperatorEnums.AND,
        name: 'And'
    },
    NOT_EQUALS: {
        key: LeadFilterConditionOperatorEnums.NOT_EQUALS,
        name: 'Not Equals'
    },
    NOT_IN: {
        key: LeadFilterConditionOperatorEnums.NOT_IN,
        name: 'Not In'
    },
    NOT_CONTAINS: {
        key: LeadFilterConditionOperatorEnums.NOT_CONTAINS,
        name: 'Not Contains'
    },
    EQUALS: {
        key: LeadFilterConditionOperatorEnums.EQUALS,
        name: 'Equals'
    },
    IN: {
        key: LeadFilterConditionOperatorEnums.IN,
        name: 'In'
    },
    CONTAINS: {
        key: LeadFilterConditionOperatorEnums.CONTAINS,
        name: 'Contains'
    },
    GREATER_THAN: {
        key: LeadFilterConditionOperatorEnums.GREATER_THAN,
        name: 'Greater Than'
    },
    LESS_THAN: {
        key: LeadFilterConditionOperatorEnums.LESS_THAN,
        name: 'Less than'
    },
    BETWEEN: {
        key: LeadFilterConditionOperatorEnums.BETWEEN,
        name: 'Between'
    },
    IS_NULL: {
        key: LeadFilterConditionOperatorEnums.IS_NULL,
        name: 'Is not available'
    },
    IS_NOT_NULL: {
        key: LeadFilterConditionOperatorEnums.IS_NOT_NULL,
        name: 'Is available'
    },
    IS_EMPTY: {
        key: LeadFilterConditionOperatorEnums.IS_EMPTY,
        name: 'Is Empty'
    },
    IS_NOT_EMPTY: {
        key: LeadFilterConditionOperatorEnums.IS_NOT_EMPTY,
        name: 'Is Not Empty'
    },
}



export const LEAD_FILTER_INPUT_FIELDS = [
    {

        key: "fullName",
        name: 'Full name',
        type: FILTER_FIELD_TYPES.STRING,
        isCustom: false,
        options: []


    },
    {

        key: "email",
        name: 'Email',
        type: FILTER_FIELD_TYPES.EMAIL,
        isCustom: false,
        options: []

    },
    {

        key: "phone",
        name: 'Phone',
        type: FILTER_FIELD_TYPES.PHONE,
        isCustom: false,
        options: []
    },
    {

        key: "stage",
        name: 'Lead Stage',
        type: FILTER_FIELD_TYPES.ARRAY,
        isCustom: false,
        options: []

    },
    {

        key: "status",
        name: 'Lead Status',
        type: FILTER_FIELD_TYPES.ARRAY,
        isCustom: false,
        options: []

    },
    {

        key: "source",
        name: 'Lead Source',
        type: FILTER_FIELD_TYPES.ARRAY,
        isCustom: false,
        options: []

    },
    // {

    //     key: "primarySource",
    //     name: 'Lead Primary source',
    //     type: FILTER_FIELD_TYPES.ARRAY,

    // },
    {

        key: "assignTo",
        name: 'Assign to',
        type: FILTER_FIELD_TYPES.ARRAY,
        isCustom: false,
        options: []

    },
    {

        key: "campaign",
        name: 'Campaign',
        type: FILTER_FIELD_TYPES.STRING,
        isCustom: false,
        options: []

    },
    {

        key: "audience",
        name: 'Audience',
        type: FILTER_FIELD_TYPES.STRING,
        isCustom: false,
        options: []

    },
    {

        key: "creative",
        name: 'Creative',
        type: FILTER_FIELD_TYPES.STRING,
        isCustom: false,
        options: []

    },
    {

        key: "createdAt",
        name: 'Lead Created Date',
        type: FILTER_FIELD_TYPES.DATE,
        isCustom: false,
        options: []

    },
    {

        key: "updatedAt",
        name: 'Lead Updated Date',
        type: FILTER_FIELD_TYPES.DATE,
        isCustom: false,
        options: []

    }, {

        key: "enquiry",
        name: 'Lead Enquiry Date',
        type: FILTER_FIELD_TYPES.DATE,
        isCustom: false,
        options: []

    },



]

export const getFieldBasedConditionOperators = (fieldType: keyof typeof FILTER_FIELD_TYPES) => {

    switch (fieldType) {
        case FILTER_FIELD_TYPES.STRING:
            return [
                FILTER_CONDITION_OPERATORS.EQUALS,
                FILTER_CONDITION_OPERATORS.NOT_EQUALS,
                FILTER_CONDITION_OPERATORS.CONTAINS,
                FILTER_CONDITION_OPERATORS.NOT_CONTAINS,
                FILTER_CONDITION_OPERATORS.IN,
                FILTER_CONDITION_OPERATORS.NOT_IN,
                FILTER_CONDITION_OPERATORS.IS_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NOT_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NULL,
                FILTER_CONDITION_OPERATORS.IS_NOT_NULL,
            ]
        case FILTER_FIELD_TYPES.NUMBER:
            return [
                FILTER_CONDITION_OPERATORS.EQUALS,
                FILTER_CONDITION_OPERATORS.NOT_EQUALS,
                FILTER_CONDITION_OPERATORS.GREATER_THAN,
                FILTER_CONDITION_OPERATORS.LESS_THAN,
                FILTER_CONDITION_OPERATORS.BETWEEN,
                FILTER_CONDITION_OPERATORS.IS_NULL,
                FILTER_CONDITION_OPERATORS.IS_NOT_NULL,
            ]
        case FILTER_FIELD_TYPES.DATE:
            return [
                // FILTER_CONDITION_OPERATORS.EQUALS,
                // FILTER_CONDITION_OPERATORS.NOT_EQUALS,
                // FILTER_CONDITION_OPERATORS.GREATER_THAN,
                // FILTER_CONDITION_OPERATORS.LESS_THAN,
                FILTER_CONDITION_OPERATORS.BETWEEN,
                FILTER_CONDITION_OPERATORS.IS_NULL,
                FILTER_CONDITION_OPERATORS.IS_NOT_NULL,
            ]
        case FILTER_FIELD_TYPES.BOOLEAN:
            return [
                FILTER_CONDITION_OPERATORS.EQUALS,
                FILTER_CONDITION_OPERATORS.NOT_EQUALS,
                FILTER_CONDITION_OPERATORS.IS_NULL,
                FILTER_CONDITION_OPERATORS.IS_NOT_NULL,
            ]
        case FILTER_FIELD_TYPES.ARRAY:
            return [
                FILTER_CONDITION_OPERATORS.IN,
                FILTER_CONDITION_OPERATORS.NOT_IN,
                FILTER_CONDITION_OPERATORS.IS_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NOT_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NULL,
                FILTER_CONDITION_OPERATORS.IS_NOT_NULL,
            ]
        case FILTER_FIELD_TYPES.EMAIL:
            return [
                FILTER_CONDITION_OPERATORS.EQUALS,
                FILTER_CONDITION_OPERATORS.NOT_EQUALS,
                FILTER_CONDITION_OPERATORS.CONTAINS,
                FILTER_CONDITION_OPERATORS.NOT_CONTAINS,
                FILTER_CONDITION_OPERATORS.IN,
                FILTER_CONDITION_OPERATORS.NOT_IN,
                FILTER_CONDITION_OPERATORS.IS_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NOT_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NULL,
                FILTER_CONDITION_OPERATORS.IS_NOT_NULL,
            ]
        case FILTER_FIELD_TYPES.PHONE:
            return [
                FILTER_CONDITION_OPERATORS.EQUALS,
                FILTER_CONDITION_OPERATORS.NOT_EQUALS,
                FILTER_CONDITION_OPERATORS.CONTAINS,
                FILTER_CONDITION_OPERATORS.NOT_CONTAINS,
                FILTER_CONDITION_OPERATORS.IN,
                FILTER_CONDITION_OPERATORS.NOT_IN,
                FILTER_CONDITION_OPERATORS.IS_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NOT_EMPTY,
                FILTER_CONDITION_OPERATORS.IS_NULL,
                FILTER_CONDITION_OPERATORS.IS_NOT_NULL,
            ]
        default:
            return []
    }

}

export const convertCustomFieldsToFilterOptions = (customFields: any[]) => {
    console.log("🚀 ~ convertCustomFieldsToFilterOptions ~ customFields:", customFields)


    const typeMapper: any = {
        TEXT: FILTER_FIELD_TYPES.STRING,
        TEXTAREA: FILTER_FIELD_TYPES.STRING,
        EMAIL: FILTER_FIELD_TYPES.STRING,
        PHONE: FILTER_FIELD_TYPES.NUMBER,
        DROPDOWN: FILTER_FIELD_TYPES.ARRAY,
        RADIO_BUTTON: FILTER_FIELD_TYPES.ARRAY,
        NUMBER: FILTER_FIELD_TYPES.NUMBER,
        DATE: FILTER_FIELD_TYPES.DATE,
        SWITCH: FILTER_FIELD_TYPES.BOOLEAN,
        SELECT: FILTER_FIELD_TYPES.ARRAY,
        MULTI_SELECT: FILTER_FIELD_TYPES.ARRAY,
        RADIO: FILTER_FIELD_TYPES.ARRAY,
        CHECKBOX: FILTER_FIELD_TYPES.ARRAY,
    }

    const sanitizedFields = customFields.filter((field) => field.type !== 'GROUP')
    return sanitizedFields?.map((field) => {

        return {
            key: field._id,
            name: field?.custom?.label || field?.name,
            isCustom: true,
            type: typeMapper[field.type],
            options: field.enums?.map((option: any) => {
                return {
                    value: option.value,
                    label: option.label
                }
            }
            )

        }
    })
}

export const EncodeAdvancedFilter = (filter: any) => {
    return btoa(JSON.stringify(filter));
    // return encodeURIComponent(JSON.stringify(filter)).replace(/%3F/g, '?').replace(/%26/g, '&')
}

export const DecodeAdvancedFilter = (filter: string | null) => {

    if (!filter) {
        return []
    }
    const decr = atob(filter)
    console.log("🚀 ~ DecodeAdvancedFilter ~ decr:", decr)
    //return JSON.parse(decodeURIComponent(filter))
    return JSON.parse(atob(filter));
}